export default "__VITE_ASSET__DvZPxouI__"